import React from 'react';

function weeklyProcessed(dailyDocs, uid) {
    return dailyDocs.slice(0, 7).reduce(
        (acc, d) => acc + (d.by_user?.[uid]?.processed || 0),
        0,
    );
}

function userWeeklyTat(dailyDocs, uid) {
    const last7 = dailyDocs.slice(0, 7);
    const ms = last7.reduce((a, d) => a + (d.by_user?.[uid]?.total_processing_time_ms || 0), 0);
    const n = last7.reduce((a, d) => a + (d.by_user?.[uid]?.processed || 0), 0);
    return n ? Math.round((ms / n / 1000 / 60) * 10) / 10 : null;
}

export default function CoordinatorTable({ members = {}, currentState, dailyDocs = [] }) {
    const rows = Object.entries(members).map(([uid, info]) => ({
        uid,
        name: info.name || uid,
        open: currentState?.open_by_user?.[uid] || 0,
        weekly: weeklyProcessed(dailyDocs, uid),
        tat: userWeeklyTat(dailyDocs, uid),
    }));
    rows.sort((a, b) => b.open - a.open);

    if (rows.length === 0) {
        return (
            <section className="dashboard-section">
                <h3>Per coordinator</h3>
                <p className="dashboard-empty">No facility members yet.</p>
            </section>
        );
    }

    return (
        <section className="dashboard-section">
            <h3>Per coordinator</h3>
            <table className="coordinator-table">
                <thead>
                    <tr><th>Name</th><th>Open</th><th>Wk processed</th><th>Avg TAT</th></tr>
                </thead>
                <tbody>
                    {rows.map((r) => (
                        <tr key={r.uid}>
                            <td>{r.name}</td>
                            <td>{r.open}</td>
                            <td>{r.weekly}</td>
                            <td>{r.tat !== null ? `${r.tat}m` : '—'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </section>
    );
}
